import { type Query as TCubeQuery } from "@cubejs-client/core"
import { useCubeQuery } from "~/ui-rtk/hooks/cube"
import { CUBE_QUERY_KEYS_MAP } from "../components/features/details/constants"

export type TCampaignAdSetAdDetailsData = {
  brandValue: number
  total: number
  purchases: number
  spend?: number
}
export type TCampaignAdSetAdDetailsItem = {
  current: TCampaignAdSetAdDetailsData
  all: TCampaignAdSetAdDetailsData
  totalItems: number
  date: string
}

export function prepareAllItemsDetails(metrics: Record<string, unknown>[]) {
  const processed = metrics.reduce<{
    brand_value_over_spend: number
    purchases: number
  }>(
    (acc, metric) => ({
      brand_value_over_spend:
        acc.brand_value_over_spend + +(metric.brand_value_over_spend as number),
      purchases: acc.purchases + +(metric.purchases as number),
    }),
    {
      brand_value_over_spend: 0,
      purchases: 0,
    },
  )
  return {
    ...processed,
    brand_value_over_spend:
      metrics.length > 0
        ? processed.brand_value_over_spend / metrics.length
        : null,
  }
}

export function useAllCampaignsAdSetsAdsDetails(allQuery: TCubeQuery) {
  const { resultSet: allSet, isLoading } = useCubeQuery(allQuery)

  return {
    isLoading,
    [CUBE_QUERY_KEYS_MAP.ALL]: allSet,
  }
}

export default function useCampaignAdSetAdDetails({
  [CUBE_QUERY_KEYS_MAP.ALL]: allQuery,
}: Record<
  (typeof CUBE_QUERY_KEYS_MAP)[keyof typeof CUBE_QUERY_KEYS_MAP],
  TCubeQuery
>) {
  const { resultSet: allSet, isLoading } = useCubeQuery(allQuery)

  return {
    isLoading,
    [CUBE_QUERY_KEYS_MAP.ALL]: allSet,
  }
}
